/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_address__summary__error__title = /** @type {(inputs: {}) => string} */ () => {
	return `Der Ort wurde nicht gefunden`
};

const en_address__summary__error__title = /** @type {(inputs: {}) => string} */ () => {
	return `Place not found`
};

const es_address__summary__error__title = /** @type {(inputs: {}) => string} */ () => {
	return `Lugar no encontrado`
};

const fr_address__summary__error__title = /** @type {(inputs: {}) => string} */ () => {
	return `Lieu introuvable`
};

const it_address__summary__error__title = /** @type {(inputs: {}) => string} */ () => {
	return `Luogo introvabile`
};

const nl_address__summary__error__title = /** @type {(inputs: {}) => string} */ () => {
	return `Locatie niet gevonden`
};

const pt_address__summary__error__title = /** @type {(inputs: {}) => string} */ () => {
	return `Local não encontrado`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const address__summary__error__title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.address__summary__error__title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("address__summary__error__title", locale)
	if (locale === "de") return de_address__summary__error__title(inputs)
	if (locale === "en") return en_address__summary__error__title(inputs)
	if (locale === "es") return es_address__summary__error__title(inputs)
	if (locale === "fr") return fr_address__summary__error__title(inputs)
	if (locale === "it") return it_address__summary__error__title(inputs)
	if (locale === "nl") return nl_address__summary__error__title(inputs)
	return pt_address__summary__error__title(inputs)
};